// Module
var code = "<div class=\"col-md-10 col-md-offset-1\">\r\n    <h2>An error occurred</h2>\r\n    <p class=\"lead\">\r\n        Access to the Community Portal is not available at this time. Please try again later.\r\n    </p>\r\n    <p>\r\n        <button data-bind=\"click: logout\" class=\"btn btn-primary mt-3\">Logout</button>\r\n    </p>\r\n</div>\r\n";
// Exports
export default code;